import React from "react";
import { Button } from "~/components/ui/button";
import { Modal } from "~/components/Modal";

// // // //

/**
 * ModeChangeConfirm Component
 *
 * Displays a modal dialog that informs the user that switching between pro search and filters will flush out the current filter state
 *
 * @component
 * @param {boolean} props.show - Determines whether the modal is visible or not.
 * @param {function} props.onDismiss - Callback function to handle modal dismiss event.
 * @param {function} props.onConfirm - Callback function to handle modal confirm event.
 */
export function ModeChangeConfirm(props: {
    show: boolean;
    onDismiss: () => void;
    onConfirm: () => void;
}) {
    const { show, onDismiss, onConfirm } = props;
    return (
        <Modal
            show={show}
            onHide={() => {
                onDismiss();
            }}
        >
            <React.Fragment>
                <div className="bg-card px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="mt-3 text-center sm:mt-0">
                        <div className="mt-3">
                            <p className="text-foreground mb-3 text-lg font-light">
                                Switching between{" "}
                                <span className="font-semibold">
                                    Pro Search
                                </span>{" "}
                                and{" "}
                                <span className="font-semibold">
                                    Basic Filters
                                </span>{" "}
                                will reset the current query.
                            </p>
                            <p className="text-foreground text-lg font-light">
                                Would you like to continue?
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-card px-4 pb-4 flex gap-2">
                    <Button
                        size="sm"
                        className="w-full"
                        variant="outline"
                        onClick={() => {
                            onDismiss();
                        }}
                    >
                        No
                    </Button>
                    <Button
                        size="sm"
                        className="w-full"
                        variant="primaryLight"
                        onClick={() => {
                            onConfirm();
                        }}
                    >
                        Continue
                    </Button>
                </div>
            </React.Fragment>
        </Modal>
    );
}
